import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import cn from 'classnames';
import useQuery from '../../../hooks/useQuery';
import Container from '../../../components/Container/Container';
import DropdownMenuElemToggle from '../../../components/DropDownMenu/DropdownMenuElemToggle/DropdownMenuElemToggle';
import Button from '../../../components/Button/Button';
import CancelIcon from '../../../components/CancelIcon/CancelIcon';
import Paragraph from '../../../components/Typography/Paragraph/Paragraph';
import SearchInput from '../../../components/Form/SearchInput/SearchInput';
import { saveFilterData } from '../../../store/reducers/Race/raceSlice';
import styles from './UpcomingRacesHeader.module.scss';
const UpcomingRacesHeader = ({ filters, onFilterClick, onChangeSearch, onMyRacesClick, myRaces }) => {
    const { t } = useTranslation();
    const [params, setParams] = useSearchParams();
    const query = useQuery();
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState(params.get('name') || '');
    const filtersCount = useMemo(() => Object.values(query).filter(Boolean).length, [query]);
    const reset = () => {
        setParams({});
        setSearchValue('');
        dispatch(saveFilterData({}));
    };
    const handleInputChange = (e) => {
        const { value } = e.target;
        onChangeSearch(value);
        setSearchValue(value);
    };
    return (_jsx("div", Object.assign({ className: styles.wrapper }, { children: _jsxs(Container, Object.assign({ className: cn('d-flex align-items-center', 'justify-content-between') }, { children: [_jsxs("div", Object.assign({ className: 'd-flex align-items-center' }, { children: [_jsx(DropdownMenuElemToggle, { label: t('my_races'), className: styles.switcher, onClick: onMyRacesClick, checked: myRaces }), _jsxs("div", Object.assign({ className: cn(styles.box, 'd-flex align-items-center') }, { children: [_jsx(Button, { height: 'xs', color: 2, onClick: onFilterClick, text: filters ? t('hide_filters') : t('show_filters').toLocaleUpperCase() }), filtersCount !== 0 && (_jsxs("div", Object.assign({ className: cn(styles.reset, 'd-flex align-items-center'), onClick: reset }, { children: [_jsx(CancelIcon, {}), _jsx(Paragraph, { title: `${t('reset')} (${filtersCount})` })] })))] }))] })), _jsx("div", { children: _jsx(SearchInput, { onChange: handleInputChange, value: searchValue, placeholder: t('search') }) })] })) })));
};
export default UpcomingRacesHeader;
